export type PairBinding = { userId: number; device: string; secret: string; transferKey: string };
export type Launch = { ticket: string; key: string };
export type NativePreferences = { mode: 'full' | 'compact'; pinned: boolean };
export type NativeBridge = {
  version: string;
  bootstrap(): Promise<NativePreferences & { ticket: Launch | null; binding: PairBinding | null; appVersion?: string }>;
  saveBinding(value: PairBinding | null): Promise<void>;
  setMode(mode: 'full' | 'compact'): Promise<NativePreferences>;
  setPinned(value: boolean): Promise<NativePreferences>;
  setBusy(value: boolean): Promise<void>;
  diagnostic?(state:'claim-start'|'claim-success'|'claim-error'|'awaiting-invitation'): Promise<void>;
  finishClose(): Promise<void>;
  openBrowser(url: string): Promise<void>;
  onLaunch(fn: (launch: Launch) => void): () => void;
  onClose(fn: () => void): () => void;
};
declare global { interface Window { skrepkaChat?: NativeBridge } }
export const nativeChat = () => window.skrepkaChat;
export function openNativeChat(url:string){window.location.href=url;}
